import * as React from 'react';
import { cn } from '../../lib/cn';

/**
 * MoneyCell — right-aligned, mono, tabular-nums currency cell.
 *
 *   <MoneyCell value={1099} />               // R 1,099.00
 *   <MoneyCell value={1099} currency="USD" /> // $1,099.00
 *   <MoneyCell value={null} />                // —
 *
 * Defaults to ZAR + en-ZA. Use inside UniversalTable column `render`.
 */

interface MoneyCellProps {
  value: number | null | undefined;
  currency?: string;
  locale?: string;
  className?: string;
  /** Override the dash shown when value is null/undefined. */
  emptyText?: string;
  /** Render zero as the dash (useful for "no charges" rows). */
  zeroAsEmpty?: boolean;
}

function MoneyCell({
  value,
  currency = 'ZAR',
  locale = 'en-ZA',
  className,
  emptyText = '—',
  zeroAsEmpty = false,
}: MoneyCellProps) {
  if (value == null || (zeroAsEmpty && value === 0)) {
    return <span className={cn('text-sm tabular-nums text-muted-foreground', className)}>{emptyText}</span>;
  }
  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(value);
  return (
    <span
      className={cn(
        'text-sm font-semibold tabular-nums text-foreground',
        className
      )}
    >
      {formatted}
    </span>
  );
}

export { MoneyCell };
export type { MoneyCellProps };
